import { render, staticRenderFns } from "./realizeBrand.vue?vue&type=template&id=34355098&scoped=true"
import script from "./realizeBrand.vue?vue&type=script&lang=js"
export * from "./realizeBrand.vue?vue&type=script&lang=js"
import style0 from "./realizeBrand.vue?vue&type=style&index=0&id=34355098&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34355098",
  null
  
)

export default component.exports